import { sendEventToKafka } from './kafkaService';
import { getStore } from '../store';
import {
  getMappedTrackProperties,
  analyticsIsLoaded,
} from './ltAnalyticsService';

let jornayaErrorHandler = null;

/**
 * Handle Jornaya script errors and send them to SumoLogic via PHX API
 */
const handleJornayaScriptError = (event) => {
  try {
    const errorData = {
      status: event.detail.status,
      statusText: event.detail.statusText,
      url: event.detail.url,
      error: event.detail.error,
      timestamp: new Date().toISOString(),
      eventType: 'JornayaScriptError',
    };

    // Add form context if available
    const store = getStore();
    if (store) {
      const state = store.getState();
      if (state && state.formMeta) {
        errorData.formId = state.formMeta.formId;
        errorData.formUuid = state.formMeta.formUuid;
        errorData.stepName = state.formMeta.stepName;
      }
    }

    // Add analytics context if available
    if (analyticsIsLoaded()) {
      const trackProperties = getMappedTrackProperties();
      errorData.clickSessionId = trackProperties.ClickSessionId;
      errorData.treeAnonymousTransientUid =
        trackProperties.TreeAnonymousTransientUid;
    }

    // Send to SumoLogic via PHX API
    sendEventToKafka('jornayaScriptError', errorData, null);
  } catch (error) {
    // Fallback - only log to console in non-production environments
    if (process.env.PHOENIX_ENVIRONMENT !== 'prod') {
      // eslint-disable-next-line no-console
      console.error('Failed to log Jornaya Script Error:', error);
      // eslint-disable-next-line no-console
      console.error('Original Jornaya Script Error:', {
        status: event.detail.status,
        statusText: event.detail.statusText,
        url: event.detail.url,
        error: event.detail.error,
        timestamp: new Date().toISOString(),
      });
    }
  }
};

/**
 * Initialize Jornaya error handling
 */
export const initJornayaErrorHandling = () => {
  if (!jornayaErrorHandler) {
    jornayaErrorHandler = handleJornayaScriptError;
    window.addEventListener('ltJornayaScriptError', jornayaErrorHandler);
  }
};

/**
 * Clean up Jornaya error handling
 */
export const deinitJornayaErrorHandling = () => {
  if (jornayaErrorHandler) {
    window.removeEventListener('ltJornayaScriptError', jornayaErrorHandler);
    jornayaErrorHandler = null;
  }
};
